// useCotisationData.js
import { useState, useEffect } from 'react';
import { apiGetCotisation } from '../../Api/Cotisation/Cotisation';

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split('T')[0].split('-');
  return `${day}/${month}/${year}`;
};

const formatMontant = (montant) => {
  return parseFloat(montant || 0).toFixed(2);
};

const transformPeriode = (periode, index) => ({
  id: index + 1,
  codePolice: periode.codepolice || '',
  dateReglement: formatDate(periode.dateReglement),
  echeanceDebut: formatDate(periode.dateDebutPeriode),
  echeanceFin: formatDate(periode.dateFinPeriode),
  color: formatMontant(periode.montantApayer) > 0 ? 'red' : 'green',
  montant: formatMontant(periode.montantApayer),
  montantDu: formatMontant(periode.montantDu),
  montantRegle: formatMontant(periode.montantRegle),
  remarque: periode.remarque || 'En attente',
  montantFrais: parseFloat(periode.montantFrais),
  statut: periode.statut,
  appelcotis: periode.appelcotis || 0,
});

export const useCotisationData = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [methodePaiement, setMethodePaiement] = useState('');
  const [codeMethodePaiement, setCodeMethodePaiement] = useState('');
  const [montantApayer, setMontantApayer] = useState('');
  const [montantAcompte, setMontantAcompte] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiGetCotisation();

        if (parseInt(result.codeerreur) !== 0) {
          throw new Error("Une erreur est survenue lors de la récupération des données." + result.codeerreur);
        }

        const { tdbCotisationTotale } = result;

        if (!tdbCotisationTotale?.tdbCotisationPeriodes) {
          setData([]);
          return;
        }

        // Recherche de la méthode de paiement
        const codeMethodePaiement = tdbCotisationTotale.typepaie?.typepaie1 || false;

        // Sauvegarde dans localStorage
        localStorage.setItem("codeMethodePaiement", codeMethodePaiement);
        
        setMethodePaiement(tdbCotisationTotale.typepaie?.tptLibelle || '-'); 
        setMontantApayer(formatMontant(tdbCotisationTotale.montantApayer));
        setMontantAcompte(formatMontant(tdbCotisationTotale.montantAcompte));
        setCodeMethodePaiement(codeMethodePaiement);

        const formattedData = tdbCotisationTotale.tdbCotisationPeriodes
          .map(transformPeriode);

        setData(formattedData);
        setError(null);
      }
       catch (error) {
        console.error("Erreur lors de la récupération des données de cotisation:", error);
        setError(error.message);
        setData([]);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    error,
    methodePaiement,
    codeMethodePaiement,
    montantApayer,
    montantAcompte,
  };
};
